export default __webpack_public_path__ + "static/media/save-cookbook-unactive.dd27ba93.svg";